module.exports = "<ng-template lfwmsDynamicWidget></ng-template>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/dynamic-widget-holder/dynamic-widget-holder.component.html
// module id = ../../../../../src/app/shared/components/widget/dynamic-widget-holder/dynamic-widget-holder.component.html
// module chunks = main